import { Box, withStyles } from '@material-ui/core';

export const PageWrapperBox = withStyles(() => ({
  root: {
    width: '100%',
    maxWidth: 426,
  },
}))(Box);
